export default class ContactForm {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        const contactFormContainer = document.querySelector('.contact-form__container');
        const contactFormToggle = document.querySelector('.contact-form__toggle');
        contactFormToggle.onclick = () => {
            contactFormToggle.blur();

            if (contactFormContainer.classList.contains('active')) {
                contactFormContainer.classList.remove('active');
                contactFormToggle.innerHTML = '<span>Contact</span>';
            } else {
                contactFormContainer.classList.add('active');
                contactFormToggle.innerHTML = '<span>Close</span>';
            }
        };

        document.addEventListener('keyup', (e) => {
            if (e.key === 'Escape' && contactFormContainer.classList.contains('active')) {
                contactFormContainer.classList.remove('active');
                contactFormToggle.innerHTML = '<span>Contact</span>';
            }
        });

        document.body.addEventListener("click", function (event) {
            if (!event.target.closest('.contact-form__container') && !event.target.closest('.contact-form__title')) {
                contactFormContainer.classList.remove('active');
                contactFormToggle.innerHTML = '<span>Contact</span>';
            }
        });
    }
}